export const shareWebUrl = 'https://yanshi.smrwl.com/website/';
export const uploadUrl = 'https://gonghui.jlu.edu.cn/website/';
export const baseServerUrl = 'https://yanshi.smrwl.com/website/';
